import "./App.css";
import "./styles/button.css";
import "./styles/card.css";
import "./styles/container.css";
import "./styles/other.css";
import "./styles/page.css";
import "./styles/text.css";
import "./styles/colors.css";
import "./styles/shadow.css";
import "./styles/common.css";
import "./styles/modal.css";
import MainPage from "./pages/MainPage";

function App() {
  return (
    <div className="app">
      <MainPage />
    </div>
  );
}

export default App;
